module.exports = __webpack_public_path__ + "img/logo.66b445a1.svg";